import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #9b9b9b;
`

const Import = ({ title = 'Import', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
    <g
      id="Page-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="icon_download" stroke="currentColor">
        <polygon id="Path" points="3.5 6.5 8 11.5 12.5 6.5 9.5 6.5 9.5 0.5 6.5 0.5 6.5 6.5"></polygon>
        <path
          d="M15.5,10.5 L15.5,14.5 C15.5,15.052 15.052,15.5 14.5,15.5 L1.5,15.5 C0.948,15.5 0.5,15.052 0.5,14.5 L0.5,10.5"
          id="Path"
        ></path>
      </g>
    </g>
  </StyledIcon>
)

Import.displayName = 'Import'
Import.needsWork = true
export default Import
